// extracted by mini-css-extract-plugin
export default {"form":"Search_form__kPVKv","inputContainer":"Search_inputContainer__Gjg15","input":"Search_input__awaUt","inputSubmit":"Search_inputSubmit__ZCcj3","hovered":"Search_hovered__qIkag"};